var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_36046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3942 7.3076H11.111V6.46239C11.111 6.23823 11.022 6.02325 10.8635 5.86474C10.705 5.70624 10.49 5.61719 10.2658 5.61719H6.885C6.66084 5.61719 6.44585 5.70624 6.28735 5.86474C6.12884 6.02325 6.03979 6.23823 6.03979 6.46239V7.3076H5.75242C5.71655 7.3076 5.68216 7.32185 5.6568 7.34721C5.63144 7.37257 5.61719 7.40697 5.61719 7.44284V8.44018C5.61719 8.51498 5.67762 8.57541 5.75242 8.57541H6.03979V11.111C6.03979 11.3435 6.03979 11.5336 6.4624 11.5336V12.1675C6.4624 12.2236 6.48466 12.2773 6.52428 12.317C6.56391 12.3566 6.61766 12.3788 6.6737 12.3788H7.51891C7.57495 12.3788 7.62869 12.3566 7.66832 12.317C7.70795 12.2773 7.73021 12.2236 7.73021 12.1675V11.5336H9.42062V12.1675C9.42062 12.2236 9.44289 12.2773 9.48251 12.317C9.52214 12.3566 9.57588 12.3788 9.63193 12.3788H10.4771C10.5332 12.3788 10.5869 12.3566 10.6265 12.317C10.6662 12.2773 10.6884 12.2236 10.6884 12.1675V11.5336C11.111 11.5336 11.111 11.3435 11.111 11.111V8.57541H11.3942C11.4312 8.57541 11.4666 8.56072 11.4928 8.53457C11.519 8.50841 11.5336 8.47294 11.5336 8.43595C11.5336 8.39897 11.519 8.3635 11.4928 8.33734C11.4666 8.31119 11.4312 8.29649 11.3942 8.29649C11.3572 8.29649 11.3217 8.31119 11.2956 8.33734C11.2694 8.3635 11.2547 8.39897 11.2547 8.43595C11.2547 8.47294 11.2694 8.50841 11.2956 8.53457C11.3217 8.56072 11.3572 8.57541 11.3942 8.57541C11.4312 8.57541 11.4666 8.56072 11.4928 8.53457C11.519 8.50841 11.5336 8.47294 11.5336 8.43595V7.44706C11.5336 7.41007 11.519 7.3746 11.4928 7.34845C11.4666 7.3223 11.4312 7.3076 11.3942 7.3076ZM7.73021 6.03979H9.42062V6.46239H7.73021V6.03979ZM6.885 10.6884C6.77292 10.6884 6.66543 10.6439 6.58617 10.5647C6.50692 10.4854 6.4624 10.3779 6.4624 10.2658C6.4624 10.1537 6.50692 10.0463 6.58617 9.967C6.66543 9.88775 6.77292 9.84322 6.885 9.84322C6.99708 9.84322 7.10457 9.88775 7.18383 9.967C7.26308 10.0463 7.3076 10.1537 7.3076 10.2658C7.3076 10.3779 7.26308 10.4854 7.18383 10.5647C7.10457 10.6439 6.99708 10.6884 6.885 10.6884ZM6.4624 8.99802V6.885H10.6884V8.99802H6.4624ZM10.2658 10.6884C10.1537 10.6884 10.0463 10.6439 9.96701 10.5647C9.88775 10.4854 9.84323 10.3779 9.84323 10.2658C9.84323 10.1537 9.88775 10.0463 9.96701 9.967C10.0463 9.88775 10.1537 9.84322 10.2658 9.84322C10.3779 9.84322 10.4854 9.88775 10.5647 9.967C10.6439 10.0463 10.6884 10.1537 10.6884 10.2658C10.6884 10.3779 10.6439 10.4854 10.5647 10.5647C10.4854 10.6439 10.3779 10.6884 10.2658 10.6884Z",
    fill: "#FF0000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56173 8.3552L1.45929 8.41317L0.0712762 5.42077L11.7578 0L14.6589 6.25438L5.65474 10.4309L4.71689 8.40905L3.56173 8.3552Z",
    fill: "#FF0000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19407 11.5108C2.53078 10.0808 2.46271 8.4459 3.00484 6.96574C3.54697 5.48558 4.65488 4.28141 6.08485 3.61812C7.51482 2.95483 9.14971 2.88676 10.6299 3.42889C12.11 3.97101 13.3142 5.07892 13.9775 6.50889",
    stroke: "#FF0000",
    strokeWidth: 0.95096
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18676 8.39991L2.71258 10.9854L4.1888 8.37128L1.18676 8.39991Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 16,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6023 9.6448L15.7048 9.58683L17.0928 12.5792L5.40625 18L2.50517 11.7456L11.5093 7.56906L12.4472 9.59095L13.6023 9.6448Z",
    fill: "#FF0000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.97 6.48924C14.6333 7.91921 14.7013 9.5541 14.1592 11.0343C13.6171 12.5144 12.5092 13.7186 11.0792 14.3819C9.64924 15.0452 8.01435 15.1132 6.53419 14.5711C5.05403 14.029 3.84986 12.9211 3.18657 11.4911",
    stroke: "#FF0000",
    strokeWidth: 0.95096
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9695 9.60009L14.4437 7.01457L12.9674 9.62872L15.9695 9.60009Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_36046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76166,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.19531 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParked);
export default __webpack_public_path__ + "static/media/parked.7534b13cc81bee5cc501f64e96e7affe.svg";
export { ForwardRef as ReactComponent };